import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginService } from './services/login.service';
import { HttpTokenInjector } from './Interceptor/http-token-injector';
import { AuthenticationGuard } from './guards/authentication.guard';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatTableModule } from '@angular/material/table';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatSortModule } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { HomeComponent } from './navigation-views/home/home.component';
import { CaseTableComponent } from './navigation-views/home/case-table/case-table.component';
import { ResetRequestComponent } from './login/recover-login/reset-request/reset-request.component';
import { ResetResponseComponent } from './login/recover-login/reset-response/reset-response.component';
import { ChartModule } from 'angular-highcharts';
import { MlroComponent } from './navigation-views/mlro/mlro.component';
import { MainNavComponent } from './main-nav/main-nav.component';
import { MatListModule } from '@angular/material/list';
import { SarComponent } from './navigation-views/sar/sar.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { SharedModule } from './shared';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    CaseTableComponent,
    ResetRequestComponent,
    ResetResponseComponent,
    MlroComponent,
    MainNavComponent,
    SarComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatSelectModule,
    MatTableModule,
    MatCheckboxModule,
    HttpClientModule,
    MatSnackBarModule,
    MatRadioModule,
    MatSidenavModule,
    MatListModule,
    MatToolbarModule,
    MatMenuModule,
    MatSortModule,
    MatTooltipModule,
    MatPaginatorModule,
    RouterModule,
    ChartModule,
    MatFormFieldModule,
    MatInputModule,
    SharedModule,
    MatAutocompleteModule,
    NgxDaterangepickerMd.forRoot()
  ],
  providers: [
    LoginService, AuthenticationGuard,
    { provide: HTTP_INTERCEPTORS, useClass: HttpTokenInjector, multi: true },
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
